/* eslint-disable */
import React, { useState, useEffect } from 'react';
import '../b2bPage/b2bPage.css';
import './contactsPage.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram, faTelegram, faYoutube, faTiktok } from '@fortawesome/free-brands-svg-icons';
import { faPhoneSquareAlt, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import { Container } from 'react-bootstrap';
import ModalContacts from './modal/ModalContacts';
import ReactGA from 'react-ga';
import { useGetClientId } from '../../hookServices/clientId';
import { useContactUsTelegramPreferred } from '../../hookServices/useContactUsTelegramPreferred';
import { TELEGRAM_BOT } from '../../environment';
import { useSearchParams } from 'react-router-dom';

export default function ContactsPage() {
  const [modalOpen, setModalOpen] = useState();
  const [searchParams] = useSearchParams();
  const station = searchParams.get('station') || 'null';
  const { t } = useTranslation();
  const { clientId } = useGetClientId();
  const { preferTelegram: preferTelegramForContact } = useContactUsTelegramPreferred();

  useEffect(() => {
    document.body.classList.add('b2b-route');
    const layout = document.getElementById('layout');
    layout?.classList.add('b2b-route-layout');
    return () => {
      document.body.classList.remove('b2b-route');
      layout?.classList.remove('b2b-route-layout');
    };
  }, []);

  return (
    <Container id="contactsPage" className="d-flex justify-content-center align-items-start mw-100">
      <div className="contactsPageGrid">
        <svg width="0" height="0" aria-hidden="true" className="contactsPageSvgDefs">
          <defs>
            <linearGradient id="contactsInstagramGradient" x1="0%" y1="100%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="#FCAF45" />
              <stop offset="22%" stopColor="#F56040" />
              <stop offset="45%" stopColor="#E1306C" />
              <stop offset="68%" stopColor="#C13584" />
              <stop offset="100%" stopColor="#833AB4" />
            </linearGradient>
          </defs>
        </svg>
        <ul className="contactsPageList" aria-label={t('contacts')}>
          {!preferTelegramForContact && (
            <li className="contactsPageListItem">
              <button
                type="button"
                id="contactsPagePhoneBox"
                className="contactsPageItem viber"
                onClick={() => {
                  setModalOpen(true);
                  ReactGA.event({
                    category: 'phoneNumbersModal',
                    action: 'open phone number modal',
                  });
                }}
              >
                <FontAwesomeIcon id="contactsPagePhoneIcon" icon={faPhoneSquareAlt} className="contactsPageItemIcon" />
                <span className="contactsPageItemLabel">{t('tapCall')}</span>
              </button>
            </li>
          )}

          <li className="contactsPageListItem">
            <a
              id="contactsPageTelegramBox"
              href={`https://t.me/${TELEGRAM_BOT}?start=${encodeURIComponent(clientId)}-${station}`}
              className="contactsPageItem telegram"
              onClick={() => {
                ReactGA.event({
                  category: 'telegram',
                  action: 'telegram',
                });
              }}
            >
              <FontAwesomeIcon id="contactsPageTelegramIcon" icon={faTelegram} className="contactsPageItemIcon" />
              <span className="contactsPageItemLabel">{t('telegram')}</span>
            </a>
          </li>

          <li className="contactsPageListItem">
            <a
              id="contactsPageEmailBox"
              href="mailto:sales@220-km.com"
              className="contactsPageItem email"
              onClick={() => {
                ReactGA.event({
                  category: 'email',
                  action: 'email',
                });
              }}
            >
              <FontAwesomeIcon id="contactsPageEmailIcon" icon={faEnvelope} className="contactsPageItemIcon" />
              <span className="contactsPageItemLabel">Email</span>
            </a>
          </li>

          <li className="contactsPageListItem">
            <a
              id="contactsPageInstaBox"
              href="https://www.instagram.com/km_220_com/"
              className="contactsPageItem instagram"
              onClick={() => {
                ReactGA.event({
                  category: 'instagram',
                  action: 'instagram',
                });
              }}
            >
              <FontAwesomeIcon id="contactsPageInstaIcon" icon={faInstagram} className="contactsPageItemIcon" />
              <span className="contactsPageItemLabel">{t('instagram')}</span>
            </a>
          </li>

          <li className="contactsPageListItem">
            <a
              id="contactsPageYoutubeBox"
              href="https://www.youtube.com/@km_220_com"
              className="contactsPageItem youtube"
              onClick={() => {
                ReactGA.event({
                  category: 'youtube',
                  action: 'youtube',
                });
              }}
            >
              <FontAwesomeIcon id="contactsPageYoutubeIcon" icon={faYoutube} className="contactsPageItemIcon" />
              <span className="contactsPageItemLabel">YouTube</span>
            </a>
          </li>

          <li className="contactsPageListItem">
            <a
              id="contactsPageTiktokBox"
              href="https://www.tiktok.com/@km_220_com"
              className="contactsPageItem tiktok"
              onClick={() => {
                ReactGA.event({
                  category: 'tiktok',
                  action: 'tiktok',
                });
              }}
            >
              <FontAwesomeIcon id="contactsPageTiktokIcon" icon={faTiktok} className="contactsPageItemIcon" />
              <span className="contactsPageItemLabel">TikTok</span>
            </a>
          </li>
        </ul>

        <ModalContacts modalOpen={modalOpen} setModalOpen={setModalOpen} />
      </div>
    </Container>
  );
}
